export enum TypeOfWithdraw {
    GROSS = 'Gross',
    NET = 'Net',
}
